import { render, staticRenderFns } from "./account-sidebar.vue?vue&type=template&id=27353e95"
import script from "./account-sidebar.vue?vue&type=script&lang=js"
export * from "./account-sidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports